import {
  MIN_DAYS_DATE_DOCUMENT,
  MAX_DAYS_DATE_DOCUMENT,
} from "../config/config";

const MIN_DAYS = 0;
const MAX_DAYS = 7;

/**
 * Obtiene fecha minima para generación factura
 * @returns
 */
export const getDateNotBefore = () => {
  let date = new Date();
  date.setDate(date.getDate() - (MIN_DAYS_DATE_DOCUMENT ?? 10) + 1); // Cuenta dia actual
  return date;
};

/**
 * Obtiene fecha maxima para generación factura
 * @returns
 */
export const getDateNotAfter = () => {
  let date = new Date();
  date.setDate(date.getDate() + (MAX_DAYS_DATE_DOCUMENT ?? 10) - 1); // Cuenta dia actual
  return date;
};

/**
 * Obtiene fecha minima para generación factura
 * Documento soporte
 * @returns
 */
export const getMinDateByTransmission = (tipoDeTransmision) => {
  if (tipoDeTransmision === 1) {
    let date = new Date();
    date.setDate(date.getDate() - (MIN_DAYS ?? 10) + 1); // Cuenta dia actual
    return date;
  }

  if (tipoDeTransmision === 2) {
    let date = new Date();
    date.setDate(date.getDate() - (MAX_DAYS ?? 10) + 1); // Cuenta dia actual
    return date;
  }
    return new Date();
};

/**
 * Obtiene fecha maxima para generación factura
 * Documento soporte
 * @returns
 */
export const getMaxDateByTransmission = (tipoDeTransmision) => {
  if (tipoDeTransmision === 1) {
      let date = new Date();
    date.setDate(date.getDate() + (MIN_DAYS ?? 10) - 1); // Cuenta dia actual
    return date;
  }

  if (tipoDeTransmision === 2) {
    let date = new Date();
    date.setDate(date.getDate() + (MAX_DAYS ?? 10) - 1); // Cuenta dia actual
    return date;
  }
    return new Date();
};

/**
 * Obtener fecha minima para fecha vencimiento
 */
export const getDateMinPay = (dateCurrent) => {
  let date = new Date(dateCurrent);
  date.setDate(date.getDate() + 1);
  return date;
};

/**
 * Fecha de pago por defecto
 * @returns
 */
export const getDatepay = () => {
  let date = new Date();
  date.setDate(date.getDate() + 1);
  return date;
};
